export enum TPrimaryRoles {
  ACTIVITIES = "Activities",
  WORKSHOPS = "Workshops",
  FOOD = "Food",
  CEREMONIES = "Ceremonies",
  SECURITY = "Security",
  FLOOR_PATROL = "Floor Patrol",
  SUPPLEMENTARY = "Supplementary",
}

export enum TSupplementaryRoles {
  JUDGING = "Judging",
  REGISTRATION = "Registration",
  SETUP = "Setup",
  CLEANUP = "Cleanup",
  HARDWARE = "Hardware",
  SLEEP = "Sleep",
  PHOTOGRAPHY = "Photography",
  DECOR = "Decor",
  MENTORSHIP = "Mentorship",
  HACKY_HOUR = "Hacky Hour",
  MEETUP = "Meetup",
}
